import { PrimaryButton } from "components/Button/style";
import styled from "styled-components";

export const ModalBody = styled.div``;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export const FooterButton = styled(PrimaryButton)`
  width: 200px;
`;

export const CarHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
`;

export const CarIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #fde8ea;
`;

export const PlacaText = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: #333;
`;

export const TableWrapper = styled.div`
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
`;

export const HistoricoTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;

  th {
    padding: 10px 12px;
    text-align: left;
    font-weight: 600;
    color: #333;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  td {
    padding: 10px 12px;
    color: #444;
    border: 1px solid #dee2e6;
  }

  tbody tr:nth-child(even) {
    background-color: #f8f9fa;
  }
`;
